import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Spin } from '../common/Ant'
import { H4 } from '../common/Headers'
import { createQueryString } from '../../utils/queryParams'
import PressureMonitorChart from './PressureMonitorChart'

class TinyPressureMonitorChart extends Component {
  static propTypes = {
    getPressureMonitorData: PropTypes.func.isRequired,
    pressureMonitorData: PropTypes.object.isRequired,
    isChartDataLoading: PropTypes.bool.isRequired,
    pillarId: PropTypes.string.isRequired,
    sidebarWidth: PropTypes.number.isRequired,
  }

  static defaultProps = {
    pressureMonitorData: {},
  }

  componentDidMount() {
    this.fetchData()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.pillarId !== this.props.pillarId) {
      this.fetchData()
    }
  }

  fetchData = () => {
    const { getPressureMonitorData, pillarId } = this.props
    const now = moment()
    const qs = createQueryString({
      startTime: moment(now)
        .subtract(1, 'd')
        .unix(),
      endTime: now.unix(),
      smooth: 'f',
    })

    getPressureMonitorData(pillarId, qs)
  }

  render() {
    const { pressureMonitorData, isChartDataLoading, sidebarWidth } = this.props
    const { data, units, uncorrectedRanges } = pressureMonitorData

    return (
      <div className="TinyPressureMonitorChart">
        {isChartDataLoading ? (
          <Spin size="large" className="w-100 center mv6" />
        ) : data && data.length ? (
          <PressureMonitorChart
            data={data}
            uncorrectedRanges={uncorrectedRanges}
            units={units}
            width={sidebarWidth || null}
            height={300}
          />
        ) : (
          <H4 className="tc">No Data Available</H4>
        )}
      </div>
    )
  }
}

export default TinyPressureMonitorChart
